import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { LoginResponse } from '../interfaces/LoginResponse';

export const HAS_RETRIED = new HttpContextToken<boolean>(() => false);

export const tokenInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<any>> => {
  const auth = inject(AuthService);
  const sharedService = inject(SharedService);
  const router = inject(Router);

  const initialReq = isRefreshEndpoint(req.url) ? req : addAuth(req, sharedService.access_token);

  return next(initialReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const detail = (error?.error as any)?.detail;

      if (isRefreshEndpoint(req.url)) {
        sharedService.clearTokens();
        router.navigate(['/login']);
        return throwError(() => error);
      }

      if (detail?.code_error === 4044) {
        sharedService.clearTokens();
        router.navigate(['/login']);
        return throwError(() => error);
      }

      const alreadyRetried = req.context.get(HAS_RETRIED);

      if (error.status === 401 && !alreadyRetried && !isRefreshEndpoint(req.url)) {
        return auth.renewToken().pipe(
          switchMap((newToken: LoginResponse) => {
            sharedService.access_token = newToken.result.token;
            sharedService.refresh_token = newToken.result.token_renew;
            if(newToken.result.user_attr) sharedService.user_attr = newToken.result.user_attr;
            const retryReq = addAuth(
              req.clone({ context: req.context.set(HAS_RETRIED, true) }),
              newToken.result.token
            );
            return next(retryReq);
          }),
          catchError((refreshErr: HttpErrorResponse) => {
            sharedService.clearTokens();
            router.navigate(['/login']);
            return throwError(() => refreshErr);
          })
        );
      }

      return throwError(() => error);
    })
  );
};

function addAuth(req: HttpRequest<any>, token: string) {
  return req.clone({
    setHeaders: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: token || '',
    },
  });
}

function isRefreshEndpoint(url: string) {
  return url.includes('/login/rt');
}
